import styled from "styled-components";
const WeekOptions = styled("div")({
  display: "grid",
  gridTemplateColumns: "auto",
  rowGap: 8
});
const WeekOptionChunk = styled("div")(
  {
    alignItems: "center",
    display: "flex",
    justifyContent: "center"
  },
  ({ external }) => external ? { color: "rgba(0, 0, 0, 0.45)" } : void 0
);
export {
  WeekOptionChunk,
  WeekOptions
};
